// An aid is written as reduced markdown in the translation files (#136), so it
// reads as text and translates as text: paragraphs, `- ` and `1. ` lists, and
// **bold**. Nothing else is interpreted.

export interface AidInline {
  text: string
  bold: boolean
}

export type AidBlock =
  | { type: 'paragraph'; inline: AidInline[] }
  | { type: 'bullets' | 'numbers'; items: AidInline[][] }

export function parseAidText(source: string): AidBlock[] {
  const blocks: AidBlock[] = []
  let paragraph: string[] = []

  const flushParagraph = () => {
    if (paragraph.length === 0) return
    blocks.push({ type: 'paragraph', inline: parseInline(paragraph.join(' ')) })
    paragraph = []
  }

  for (const rawLine of source.split('\n')) {
    const line = rawLine.trim()
    const bullet = line.match(/^[-*]\s+(.*)$/)
    const number = line.match(/^\d+[.)]\s+(.*)$/)
    const listItem = bullet ?? number

    if (!line) {
      flushParagraph()
    } else if (listItem) {
      flushParagraph()
      const type = bullet ? 'bullets' : 'numbers'
      const last = blocks[blocks.length - 1]
      const item = parseInline(listItem[1])
      if (last && last.type === type) last.items.push(item)
      else blocks.push({ type, items: [item] })
    } else {
      paragraph.push(line)
    }
  }
  flushParagraph()
  return blocks
}

export function parseInline(text: string): AidInline[] {
  return text
    .split(/(\*\*[^*]+\*\*)/)
    .filter(Boolean)
    .map((part) =>
      part.startsWith('**') && part.endsWith('**') && part.length > 4
        ? { text: part.slice(2, -2), bold: true }
        : { text: part, bold: false }
    )
}
